import React from "react";
import { useTranslation } from "react-i18next";

import { Heading } from "../../../components/heading/Heading";
import { AsyncImg } from "../../../components/async-img/AsyncImg";
import { ViewSection } from "../../../components/view-section/ViewSection";
import { Layout } from "../../../components/layout/Layout";
import { SubTitle } from "../../../components/sub-title/SubTitle";
import digitalTradingBannerImage from "./assets/digitalTradingBannerImage3.png";
import digitalTradingMobileBannerImage from "./assets/digitalTradingMobileBannerImage.png";
import { useWindowDimensionsContext } from "../../../components/windowDimensionsProvider/WindowDimensionsProvider";

import styles from "./product-digital-trading-banner-section.module.scss";

export interface ProductDigitalTradingBannerSectionProps {}

export const ProductDigitalTradingBannerSection: React.FC<ProductDigitalTradingBannerSectionProps> = () => {
  // access translation keys
  const { t } = useTranslation();
  const { isMobile } = useWindowDimensionsContext();

  return (
    <div className={styles.wrap}>
      <div className={styles["banner-wrap"]}>
        <AsyncImg className={styles.banner} src={digitalTradingBannerImage} />
      </div>
      {isMobile && <AsyncImg className={styles["mobile-banner"]} src={digitalTradingMobileBannerImage} />}

      <ViewSection className={styles.content} image={""} gap="GAP_40">
        <SubTitle className={styles.subtitle}>{t("Discover your Edge in Trading")}</SubTitle>
        <Heading className={styles.title} level={2}>
          <span
            dangerouslySetInnerHTML={{
              __html: t("<strong>The Easiest Way to Start Trading — Without the Usual Struggles</strong>"),
            }}
          />
        </Heading>

        <p className={styles.text}>
          {t(
            "The world of trading is full of opportunity — but navigating it alone is where many get stuck. What truly makes the difference is being part of the right community and having access to the right tools, insights, and opportunities. That’s exactly what TDX brings you — at no cost whatsoever. Yes, completely free. Read on and take full advantage of the powerful solutions now available to you!",
          )}
        </p>

        <Layout className={styles["button-wrap"]} wrap="MOBILE"></Layout>

        {/* <p className={styles["pricing-note"]}>{t("Price for non sf suite customers: 399$ per year")}</p> */}
        {/* <Link className={styles["link"]} to={""} externalUrl={"https://www.sfsuite.com/membors"}>
          <IconLink width={14} height={14} />
          Membors
        </Link> */}
      </ViewSection>
    </div>
  );
};
